// Liquidity calculator layout
export const LIQUIDITY_CALCULATOR_CHART_HEIGHT_PX = 460;
export const LIQUIDITY_CALCULATOR_CHART_MIN_HEIGHT_PX = 200;
export const LIQUIDITY_CALCULATOR_LAYOUT_BREAKPOINT_PX = 1000;

// Liquidity-need details modal/graph
export const LIQUIDITY_NEED_DETAILS_CHART_HEIGHT_PX = 450;
export const LIQUIDITY_NEED_DETAILS_DEFAULT_VISIBLE_COLUMNS = 15;
export const LIQUIDITY_NEED_DETAILS_MIN_VISIBLE_COLUMNS = 5;

// The reserved, system-managed placeholder talking point is linked to the "Free liquidity
// for investments in securities" advisory need (900000000001).
export const LIQUIDITY_PLACEHOLDER_TALKING_POINT_ID = 900000000002;
export const LIQUIDITY_WEALTH_TOPIC_KEY = 'WEALTH';
